import Lookup from './lookup.js';

export default class District extends Lookup
{

}
